import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiZap, FiX } = FiIcons;

const LimitReachedModal = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/90 backdrop-blur-md text-left">
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in duration-300">
        <div className="p-8 text-center">
          <div className="w-20 h-20 bg-amber-50 dark:bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiZap} className="w-10 h-10 text-amber-500" />
          </div>
          
          <h2 className="text-2xl font-black text-slate-900 dark:text-white mb-3">Search Limit Reached</h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed mb-8">
            You've used all 10 free searches for this month. Subscribe to PartScouter Pro for unlimited access to our 25,000+ component database.
          </p>

          <div className="space-y-3">
            <button 
              onClick={() => navigate('/pricing')}
              className="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white font-black rounded-2xl transition-all shadow-lg shadow-blue-900/20 flex items-center justify-center gap-2"
            >
              Unlock Unlimited Access
            </button>
            <button 
              onClick={onClose}
              className="w-full py-4 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold rounded-2xl hover:bg-slate-200 dark:hover:bg-slate-700 transition-all"
            >
              Maybe Later
            </button>
          </div>
        </div>
        
        <div className="bg-slate-50 dark:bg-slate-950 p-4 border-t border-slate-100 dark:border-slate-800 flex items-center gap-3">
          <SafeIcon icon={FiAlertCircle} className="text-blue-500 w-4 h-4" />
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
            Pro users also get advanced cross-references
          </p>
        </div>
      </div>
    </div>
  );
};

export default LimitReachedModal;